import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Routes from './routes/Routes';
const PrivateComponent = lazy(() => import('./containers/login/private.route'));

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<div>Loading...</div>}>
      <PrivateComponent component={Routes} />
    </Suspense>
    {/* <Routes /> */}
  </React.StrictMode>,
  document.getElementById('root'),
);
